import { render, staticRenderFns } from "./TheAccountOwner.vue?vue&type=template&id=153688ee&scoped=true"
import script from "./TheAccountOwner.vue?vue&type=script&lang=js"
export * from "./TheAccountOwner.vue?vue&type=script&lang=js"
import style0 from "./TheAccountOwner.vue?vue&type=style&index=0&id=153688ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153688ee",
  null
  
)

export default component.exports